var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 32.4639H24V29.2639H16C9.056 29.2639 3.2 23.4079 3.2 16.4639C3.2 9.51987 9.056 3.66387 16 3.66387C22.944 3.66387 28.8 9.51987 28.8 16.4639V18.7519C28.8 20.0159 27.664 21.2639 26.4 21.2639C25.136 21.2639 24 20.0159 24 18.7519V16.4639C24 12.0479 20.416 8.46387 16 8.46387C11.584 8.46387 8 12.0479 8 16.4639C8 20.8799 11.584 24.4639 16 24.4639C18.208 24.4639 20.224 23.5679 21.664 22.1119C22.704 23.5359 24.496 24.4639 26.4 24.4639C29.552 24.4639 32 21.9039 32 18.7519V16.4639C32 7.63187 24.832 0.463867 16 0.463867C7.168 0.463867 0 7.63187 0 16.4639C0 25.2959 7.168 32.4639 16 32.4639ZM16 21.2639C13.344 21.2639 11.2 19.1199 11.2 16.4639C11.2 13.8079 13.344 11.6639 16 11.6639C18.656 11.6639 20.8 13.8079 20.8 16.4639C20.8 19.1199 18.656 21.2639 16 21.2639Z","fill":"white"}));
}

Email.defaultProps = {"viewBox":"0 0 32 33","fill":"none"};

module.exports = Email;

Email.default = Email;
